import {createSelector} from 'reselect';
import {getSettings} from '../selectors';

export default createSelector(
  [getSettings],
  (settings) => (settings?.rokt_complete_page_placement?.id) || 'invalid_id',
);
